import React, { Component } from 'react'
import moment from "moment";
import config from '../../config';
import { connect } from 'react-redux';
import { DISPATCH_ID } from '../../libs/utils/Const';
import { NavBar, BreadCumb, TimeOut, GenericTable, DataTables } from '../../components';
import { ApiClient } from "../../libs/apiClient";
let apiClient = ApiClient.getInstance();

const headers = [
    { title: "Serie", value: true },
    { title: "Status", value: true },
    { title: "Num.Doc", value: true },
    { title: "Folio", value: true },
    { title: "Fecha", value: true },
    { title: "User ID", value: true },
    { title: "Usuario", value: true },
    { title: "Comentarios", value: true },
    { title: "Total", value: true }

];


class SuggestedRefillModule extends Component {
    constructor(props) {
        super(props)
        this.state = {
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'))
            , data: []

        };
    }

    componentDidMount = async () => {
        const today = moment(new Date()).format('YYYYMMDD');
        const date = {
            dateInit: today,
            dateFinal: today,
        }
        await this.callDocumentsListService(date);
    }

    callDocumentsListService = async filters => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;

        const defaultWhs = this.state._user?.Branch?.ProjectCode ?? "--";
        const data = {
            dateInit: filters.dateInit,
            dateFinal: filters.dateFinal,
            table: "SRFM",
            docNumSearch: filters.docNumSearch ? filters.docNumSearch === '' ? '--' : filters.docNumSearch : '--',
            searchByWhs: defaultWhs ? defaultWhs === '' ? '--' : defaultWhs : '--'
        };

        enableSpinner(true);
        let responseApi = await apiClient.getSuggestRefillDocs(data);
        responseApi = Array.isArray(responseApi?.data) ? responseApi?.data : [];
        console.log(responseApi);
        enableSpinner(false);

        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));

        let ValidateSeries = user.U_FMB_SeriesSugerido ? user.U_FMB_SeriesSugerido : "";

        if (!user || ValidateSeries === "") {
            this.setState({ data: [] });
            return showAlert({ type: 'warning', timeOut: 5000, message: "Ocurrio un error en obtener las series permitidas para el usuario, intente reiniciar la sesión o contactar con su administrador" });
        }

        let newArraySeries = ValidateSeries.split("|");
        if (newArraySeries.length === 0) { return showAlert({ type: 'warning', timeOut: 5000, message: "El usuario no tiene serie permitida de escritura y lectura" }); }


        let newDocumentsfilterSeries = [];

        for (const document of responseApi) {
            for (const serie of newArraySeries) {
                if (Number(document.Branch) === Number(serie)) { newDocumentsfilterSeries.push(document); }
            }
        }

        if ((filters.docNumSearch && filters.docNumSearch !== '--') || (filters.searchSerieName !== '--' && filters.searchSerieName)) {
            newDocumentsfilterSeries = responseApi;
        }

        this.setState({ data: newDocumentsfilterSeries });
    }

    render() {
        const { _user } = this.state
        return (
            <div className="content">
                <NavBar props={this.props} _user={_user} />
                <TimeOut />
                <BreadCumb subitem1={'SUGERIDO DE RESURTIDO'} url1={'#'} />
                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>
                    <h2 className="md-display-1">
                        <label className="text-muted">SUGERIDO DE RESURTIDO</label>
                    </h2>

                    <DataTables
                        headers={headers}
                        view={"suggestRefill"}
                        data={this.state.data}
                        search={this.callDocumentsListService}
                    />

                </div>
            </div>
        )
    }

}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SuggestedRefillModule);

